
import React from "react";
import { Card } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import { Building2 } from "lucide-react";
import BusinessProfileForm from "@/components/settings/BusinessProfileForm";

interface ProfileTabContentProps {
  businessData: any;
  updateBusinessData: (key: string, value: string | string[] | number | Record<string, string>) => void;
  updateMultipleFields?: (updates: Record<string, string | string[] | number | Record<string, string>>) => void;
}

const ProfileTabContent: React.FC<ProfileTabContentProps> = ({ 
  businessData, 
  updateBusinessData,
  updateMultipleFields
}) => {
  return (
    <Card className="p-6">
      <div className="flex items-center gap-2 mb-4">
        <Building2 className="text-primary h-6 w-6" />
        <h3 className="text-2xl font-medium">Business Information</h3>
      </div>
      
      <Separator className="mb-6" />

      <BusinessProfileForm 
        businessData={businessData} 
        updateBusinessData={updateBusinessData}
        updateMultipleFields={updateMultipleFields}
      />
    </Card>
  );
};

export default ProfileTabContent;
